<template>
    <li @click.prevent="selectSwatch"
        class="swatch"
        :class="{'smaller': swatchIndex > 10, 'active-swatch': isActiveSwatch}"
        :style="swatchStyle(color)">
        <div class="label">
            <input ref="hexInput" type="text" :value="hex"
                   style="position: absolute; left: 99999px;">
            <span ref="hex" class="hex">{{ hex }}</span>
            <span ref="copiedSuccess" class="copied-success">copied</span>
        </div>
    </li>
</template>

<script>
import {backgroundCSS}   from '../../../../../Lib/helpers/cssOutput';
import UsesActivePalette from './UsesActivePalette';
import ActivePalette     from '../../../Store/ActivePalette';
import Color             from '../../../../../Lib/Color';

export default {
    name: 'Swatch',
    extends: UsesActivePalette,

    props: {
        color: {},
        paletteId: {},
        swatchIndex: {},
    },

    computed: {
        isActiveSwatch() {
            return this.$route.name !== 'palettes' && new ActivePalette().getActiveSwatchIndex() === this.swatchIndex;
        },
        hex() {
            return Color.fromRGB(this.color).hex().value;
        },
    },

    methods: {
        swatchStyle(color) {
            return backgroundCSS(color);
        },

        selectSwatch() {
            new ActivePalette().activate(this.paletteId, this.swatchIndex);
            this.navigateToColorPicker();
            this.copyHex();
            this.animateCopiedSuccess();
        },

        navigateToColorPicker() {
            if(this.$route.name !== 'colors') {
                this.$router.push({name: 'colors'});
            }
        },

        copyHex() {
            let el = this.$refs.hexInput;

            el.select();
            el.setSelectionRange(0, 9999);
            document.execCommand('copy');
        },

        animateCopiedSuccess() {
            TweenMax.fromTo(
                this.$refs.copiedSuccess,
                .25,
                {
                    y: 16,
                    alpha: 1,
                },
                {
                    y: 2,
                },
            );
            TweenMax.set(this.$refs.hex, {y: -16});
            TweenMax.to(
                this.$refs.copiedSuccess,
                .25,
                {
                    y: 16,
                    alpha: 0,
                    delay: 1,
                },
            );
            TweenMax.to(
                this.$refs.hex,
                .25,
                {
                    y: 2,
                    delay: 1,
                },
            );
        },
    },
}
</script>

<style lang="scss" scoped>
.swatch {
    display: flex;
    justify-content: center;
    align-items: flex-end;
    position: relative;

    &:hover {
        .label {
            opacity: 1;
        }
    }

    .label {
        position: absolute;
        opacity: 0;
        font-size: 10px;
        color: #444;
        background: #fff;
        padding: 2px;
        border-radius: 3px;
        margin-bottom: 5px;

        bottom: 2px;

        transition: opacity 200ms ease-in-out;

        text-align: center;

        width: 58px;
        height: 18px;

        overflow: hidden;
    }

    .hex {
        position: absolute;
    }

    .copied-success, .hex {
        position: absolute;
        width: 58px;
        left: 0;
    }

    .copied-success {
        text-transform: uppercase;
        opacity: 0;
    }

}
</style>
